import { useLazyQuery } from "@apollo/client";
import { useCallback } from "react";

import getOrganizationSettingsQuery from "@apps/org-settings/graphql/get-organization-settings-query";
import usePusher from "@components/use-pusher/use-pusher";

export default function HRISSyncComplete({
  channelName,
}: {
  channelName: string;
}) {
  const query = getOrganizationSettingsQuery;
  const [getOrganizationSettings] = useLazyQuery(query, {});

  const handleChange = useCallback(
    ({ organization_id }: { organization_id: number }) => {
      getOrganizationSettings({
        variables: { organizationId: organization_id },
      });
    },
    [getOrganizationSettings],
  );

  usePusher(channelName, "hris_sync_complete", handleChange);

  return null;
}
